import { createSlice } from '@reduxjs/toolkit';
export const SERVER_ERROR_FEATURE_KEY = 'serverError';

export interface ServerErrorState {
  messageError: string;
  detailedMessageError: string;
  traceId: string;
}
const initialState: ServerErrorState = {
  messageError: '',
  detailedMessageError: '',
  traceId: '',
};

export const serverErrorSlice = createSlice({
  name: SERVER_ERROR_FEATURE_KEY,
  initialState: initialState,
  reducers: {
    showError: (state, action) => {
      state.messageError = action.payload.messageError;
      state.detailedMessageError = action.payload.detailedMessageError;
      state.traceId = action.payload.traceId;
    },
    hiddeError: (state) => {
      state.messageError = '';
      state.detailedMessageError = '';
      state.traceId = '';
    },
  },
});
export const serverErrorReducer = serverErrorSlice.reducer;
export const serverErrorActions = serverErrorSlice.actions;
